document.addEventListener("DOMContentLoaded", () => {

  const slider = document.querySelector(".grid-overflow-wrapper");
  const slides = document.querySelectorAll(".grid-overflow-wrapper .custom-cards__item");
  const dotsContainer = document.querySelector(".cards-dots");

  if (!slider || !slides.length || !dotsContainer) return;

  slides.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.classList.add("card-dot");
    if (index === 0) dot.classList.add("active");

    dot.addEventListener("click", () => {
      const slideWidth = slides[0].offsetWidth + 12;
      slider.scrollTo({
        left: slideWidth * index,
        behavior: "smooth",
      });
    });

    dotsContainer.appendChild(dot);
  });

  const dots = document.querySelectorAll(".card-dot");

  slider.addEventListener("scroll", () => {
    const slideWidth = slides[0].offsetWidth + 16;
    const index = Math.round(slider.scrollLeft / slideWidth);

    dots.forEach((dot) => dot.classList.remove("active"));
    if (dots[index]) dots[index].classList.add("active");
  });

  const items = document.querySelectorAll('.custom-cards__item');

  const observer = new IntersectionObserver(entries => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('show');
        }, index * 200);
      }
    });
  });

  items.forEach(el => observer.observe(el));
});
